<div class="header">
  <img class="logo" [alt]="altText()" [src]="imgSrc()" [attr.width]="imgWidth()" [attr.height]="imgHeight()" />
</div>
